import bulkBonusDetails from "./bulkBonusDetails.component";
import bulkBonusDetailsUrls from "./bulkBonusDetails.urls";
import BulkBonusDetailsTransforms from "./bulkBonusDetails.transforms";

const bulkBonusDetailsModule = angular
  .module("app.components.bulkBonusDetails", [])
  .component("bulkBonusDetailsPage", bulkBonusDetails)
  .service("BulkBonusDetailsTransforms", BulkBonusDetailsTransforms)
  .config(bulkBonusDetailsUrls);

export default bulkBonusDetailsModule;



// WEBPACK FOOTER //
// ./src/pages/bulkBonusDetails/bulkBonusDetails.module.js